import 'bootstrap/dist/css/bootstrap.min.css';
import Forms from './components/Forms';
import './App.css'


function App() {
  return (
    <div>
      <Forms />
    </div>
  )
}

export default App
